import { createContext } from "react";
import type { TooltipStore } from "../TooltipProvider.types";

const TooltipStoreContext = createContext<TooltipStore | undefined>(undefined);
TooltipStoreContext.displayName = "TooltipStoreContext";

export default TooltipStoreContext;
